import React from 'react';
import { useTranslation } from 'react-i18next';
import { EMPTY_VALUES } from '../../../../../../Apis/functions';
import ResumeInfoCard from '../../../../../../components/ResumeInfoCard';
import NotInformation from '../../../../../../components/NotInformation';
import { IconIdentificationCard, KeyIcon } from '../../../../../../components/buttons/IconButtons';
import CustomTooltip from "../../../../../../components/CustomTooltip";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const SummaryCardsInfoCard = ({ cardsList }) => {
    const { t } = useTranslation();
    return (
        <ResumeInfoCard
            title={t('cards')}
            titleIcon={<IconIdentificationCard width={24} height={24} />}
            icon={<KeyIcon className='btn-icon-svg-24px icon-color-general-950' />}
            iconClass='background-primary-100'
            contentClass={"py-3"}
            body={
                <div className='row'>
                    {cardsList?.length > 0 ? (
                        cardsList.map((card, index) => (
                            <div key={index} className='col-sm-12 col-md-6 mb-2 px-1'>
                                <div className='d-flex justify-content-between align-items-center p-2 background-shades-50 border-radius-8px'>
                                    <CustomTooltip
                                        text={`${card.number || EMPTY_VALUES.DEFAULT}`}
                                        classes={"fs-14px font-color-shades-950 ibl-font-w-600 text-ellipsis-1-row mr-4"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                    &nbsp;
                                    <CustomTooltip
                                        text={`${t('facilityCode')}: ${card.facilityCode || EMPTY_VALUES.DEFAULT}`}
                                        classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                    &nbsp;
                                    <CustomTooltip
                                        text={`${t('format')}: ${card.cardTypeName || EMPTY_VALUES.DEFAULT}`}
                                        classes={"fs-14px font-color-shades-950 ibl-font-w-300 text-ellipsis-1-row"}
                                        showIfTruncated={true}
                                        placement={"top"}
                                    />
                                </div>
                            </div>
                        ))
                    ) : (
                        <div className='col-12'>
                            <NotInformation text={t('no_information')} card={true}/>
                        </div>
                    )}
                </div>
            }
        />
    );
};

export default SummaryCardsInfoCard;
